import RootLayout from '@/layouts/RootLayout.vue';

/**
 * 专题-模块
 */
var special = {
  path: '/brandIndex',
  redirect: '/brandIndex',
  component: RootLayout,
  children: [{
    path: 'makeDraw',
    name: 'MakeDraw',
    redirect: {
      name: 'MakeDraw2'
    }
  }]
};
export default special;